// Íconos de trazo del panel, del mismo estilo que los de la landing.
const paths = {
    home: "M3 11l9-8 9 8M5 10v10h14V10",
    box: "M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5 9-5V8M12 13v8",
    qr: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3",
    store: "M4 9l1.5-5h13L20 9M4 9h16M4 9v11h16V9M9 20v-6h6v6",
    card: "M3 6h18v12H3zM3 10h18M7 15h4",
    plus: "M12 5v14M5 12h14",
    minus: "M5 12h14",
    search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-4-4",
    edit: "M4 20h4L19 9l-4-4L4 16v4zM13.5 6.5l4 4",
    trash: "M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6",
    copy: "M9 9h11v11H9zM5 15H4V4h11v1",
    share: "M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8.6 13.5l6.8 4M15.4 6.5l-6.8 4",
    download: "M12 4v11M7 10l5 5 5-5M5 20h14",
    print: "M7 9V3h10v6M7 17H4v-7h16v7h-3M7 14h10v7H7z",
    external: "M14 4h6v6M20 4l-9 9M18 14v6H4V6h6",
    check: "M5 12.5l4.5 4.5L19 7",
    alert: "M12 7v6M12 17v.01",
    logout: "M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10",
    close: "M6 6l12 12M18 6L6 18",
    up: "M12 19V5M5 12l7-7 7 7",
    refresh: "M20 12a8 8 0 1 1-2.34-5.66L20 8.5M20 3.5v5h-5",
    chart: "M4 4v16h16M8 15l3.5-4 3 2.5L20 7",
    funnel: "M3 4h18l-7 8.5V19l-4 2v-8.5L3 4z",
    cart: "M3 4h2.5l2.2 10.5h10.6L20.5 7H6.6M9 20h.01M17 20h.01",
    money: "M3 6h18v12H3zM12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM6.5 12h.01M17.5 12h.01",
    clock: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7v5l3.5 2",
    star: "M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.8l-5.2 2.8 1-5.8-4.3-4.1 5.9-.9L12 3.5z",
    eye: "M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
    grid: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
    truck: "M2 6h12v10H2zM14 9.5h4l3 3.5v3h-7M6 19.5a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zM17.5 19.5a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6z",
    whatsapp: "M3.5 20.5l1.3-4.2A8.5 8.5 0 1 1 8 19.3l-4.5 1.2zM9 8.5c0 3.5 3 6.5 6.5 6.5l1-1.5-2-1-1 1c-1.2-.5-2.5-1.8-3-3l1-1-1-2-1.5 1z",
    arrow: "M5 12h14M13 6l6 6-6 6",
    chevron: "M6 9l6 6 6-6",
    receipt: "M6 3h12v18l-3-2-3 2-3-2-3 2V3zM9 8h6M9 12h6M9 16h3",
    camera: "M3 8h4l2-3h6l2 3h4v12H3zM12 10a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z",
    sparkle: "M11 3l1.9 5.1L18 10l-5.1 1.9L11 17l-1.9-5.1L4 10l5.1-1.9L11 3zM18.5 14.5l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9.9-2.1z",
    send: "M4 12l16-8-6 16-2.5-6.5L4 12zM11.5 13.5L20 4",
    mic: "M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zM5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M9 21h6",
    play: "M8 5.5v13l10.5-6.5L8 5.5z",
    pause: "M8 5v14M16 5v14"
};

const Icon = ({ name, size = 20, strokeWidth = 2 }) => {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        <path d={paths[name]}></path>
    </svg>
  )
}

export default Icon
